import { CircularProgress, createStyles, Fade, Theme, WithStyles, withStyles } from '@material-ui/core'
import React from 'react'
import { RouteComponentProps } from 'react-router'

import { getParticipantInfoById } from '../../services/enrollment.service'
import ParticipantInfo from '../Templates/ParticipantInfo/ParticipantInfo'

interface ParticipantLandingProps extends WithStyles<typeof styles> {}

export type RouterProps = ParticipantLandingProps &
	RouteComponentProps<{
		activityID: string
		participantID: string
	}>

export const ParticipantLanding: React.FC<RouterProps> = (props: RouterProps) => {
	const { classes, match } = props
	const { activityID, participantID } = match.params
	const [participant, setParticipant] = React.useState()
	const [loading, setLoading] = React.useState(true)

	const getParticipantInfo = async () => {
		const participantInfo = await getParticipantInfoById(activityID, participantID)
		setParticipant(participantInfo)
	}

	React.useEffect(() => {
		getParticipantInfo().catch((e) => console.log(e))
		setLoading(false)
	}, [])

	return (
		<div className={classes.root}>
			{loading ? (
				<CircularProgress className={classes.progress} size={50} />
			) : (
				<Fade in={!loading} timeout={{ enter: 1000 }}>
					<ParticipantInfo participant={participant} />
				</Fade>
			)}
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		progress: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			marginTop: '-20px',
			marginLeft: '-20px',
		},
	})

export default withStyles(styles)(ParticipantLanding)
